var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VTextarea',{attrs:{"value":_vm.value,"label":"Impression Tracker Secure","outlined":""},on:{"input":_vm.emitModelValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }